const factSet = { id: 1, name: 'FactSet' }
const sec = { id: 6, name: 'SEC (CIK)' }
const auditAnalytics = { id: 7, name: 'Audit Analytics' }
const iss = { id: 10, name: 'ISS' }

export default {
    1: factSet,
    6: sec,
    7: auditAnalytics,
    10: iss,
    factSet,
    sec,
    auditAnalytics,
    iss,
    all: [auditAnalytics, factSet, iss],
}
